// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.active {
    background: var(--primary-color) !important;
    color: white;
}

.active:hover {
  background: grey !important;
  color: white;
}

/*/deep/.navigation-tree-item .mat-list-item {
    min-height: 48px;
    height: auto !important;
    display: flex !important;
    flex-direction: column;
}
/deep/.navigation-tree-item .mat-list-item-content {
    flex: 1 1 auto;
    padding: 0 !important;
}*/
.navigation-item{
  /*align-self:center;*/
  padding: 0 24px !important;
}

a.mat-list-item-content.ng-star-inserted {
    background-color: var(--primary-color) !important;
}
.title {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width:100%;
}

.navigation-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/navigationtree/navigationtree.item.css"],"names":[],"mappings":";AACA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;;;;;;EASE;AACF;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;IACI,iDAAiD;AACrD;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["\n.active {\n    background: var(--primary-color) !important;\n    color: white;\n}\n\n.active:hover {\n  background: grey !important;\n  color: white;\n}\n\n/*/deep/.navigation-tree-item .mat-list-item {\n    min-height: 48px;\n    height: auto !important;\n    display: flex !important;\n    flex-direction: column;\n}\n/deep/.navigation-tree-item .mat-list-item-content {\n    flex: 1 1 auto;\n    padding: 0 !important;\n}*/\n.navigation-item{\n  /*align-self:center;*/\n  padding: 0 24px !important;\n}\n\na.mat-list-item-content.ng-star-inserted {\n    background-color: var(--primary-color) !important;\n}\n.title {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width:100%;\n}\n\n.navigation-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
